import { useEffect, useMemo, useState } from 'react';
import classnames from 'classnames';
import { Row, Tree, Typography } from 'antd';
import { Droppable } from 'react-beautiful-dnd';
import { DownOutlined, DragOutlined } from '@ant-design/icons';

import useCustomScroll from 'hooks/useCustomScroll';
import { useRenderTree } from '../hook/renderTree';
import './QueryCondition.less';

const nameClass = 'query-conditions';

const QueryConditions = (props) => {
  useCustomScroll(`.${nameClass}`);
  const {
    viewMode,
    draggingTaskId,
    queryConditions,
    propertiesData,
    fetchEntityAttribute,
    queryConditionsId = 'query-conditions',
    entityType,
    ...restProp
  } = props;

  const [keyCollapse, setKeyCollapse] = useState([]);
  const { mappingTreeTitle } = useRenderTree();

  const propertiesList =
    window?.advancedSearch?.entityAttributes?.[entityType] ?? propertiesData;

  let mappingTreeData = useMemo(
    () =>
      mappingTreeTitle({
        viewMode,
        draggingTaskId,
        queryConditionsId,
        queryConditions,
        propertiesList,
        ...restProp,
      }),
    [JSON.stringify(queryConditions), draggingTaskId, viewMode]
  );

  const onExpand = (key, { node }) => {
    let cloneKeyCollapse = [...keyCollapse];

    if (cloneKeyCollapse.includes(node?.key)) {
      cloneKeyCollapse = cloneKeyCollapse.filter((item) => item !== node?.key);
    } else {
      cloneKeyCollapse.push(node?.key);
    }
    setKeyCollapse(cloneKeyCollapse);
  };

  useEffect(() => {
    if (mappingTreeData) setKeyCollapse(mappingTreeData?.collapseKey);
  }, [JSON.stringify(queryConditions)]);

  const isDropDisabled =
    draggingTaskId?.draggableId.indexOf('_column') > -1 ? true : false;

  return (
    <>
      <Droppable
        droppableId={'query_conditions'}
        isCombineEnabled={true}
        isDropDisabled={isDropDisabled}
      >
        {(provided) => (
          <div
            ref={provided.innerRef}
            {...provided.droppableProps}
            className={classnames({
              'query-conditions scroller-extend': true,
            })}
            id={queryConditionsId}
          >
            {queryConditions?.children?.length > 0 ? (
              <Tree
                showLine={{ showLeafIcon: false }}
                switcherIcon={<DownOutlined />}
                treeData={[mappingTreeData].slice()}
                expandedKeys={keyCollapse}
                onExpand={onExpand}
                selectable={false}
              />
            ) : (
              <Row className='data-columns__none-data'>
                <DragOutlined className='data-columns__none-data-icon' />
                <Typography.Title level={5}>
                  Drag Attributes to this area to Query Conditions
                </Typography.Title>
              </Row>
            )}

            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </>
  );
};

export default QueryConditions;
